import { render, staticRenderFns } from "./CreateDispute.vue?vue&type=template&id=f64a634c&scoped=true&"
import script from "./CreateDispute.vue?vue&type=script&lang=js&"
export * from "./CreateDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64a634c",
  null
  
)

export default component.exports